import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { w as waitForAnimation } from './p-rUtJRH95.js';
import { c as createPopper, d as destroyPopper } from './p-D_OOeJgV.js';

const tooltipLabelCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;background-color:var(--jw-theme-neutral-tooltip-message-bg-color);border-radius:.375rem;box-sizing:border-box;color:var(--jw-theme-neutral-tooltip-message-color);display:none;flex-direction:column;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;z-index:var(--jw-z-index-tooltips)}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host([open]){animation:u3qiyqu .25s ease}@keyframes u3qiyqu{0%{opacity:0}10%{opacity:0}to{opacity:1}}:host(:not([open])){animation:u3qiyrq .25s ease}@keyframes u3qiyrq{0%{opacity:1}90%{opacity:0}to{opacity:0}}.inner{max-width:var(--jw-container-xs);min-width:2rem;padding:.5rem 1rem;position:relative;text-align:center;white-space:nowrap}.inner[data-chars]{white-space:normal;width:30ch}.arrow{height:12px;visibility:hidden;width:12px}.arrow,.arrow:before{background:var(--jw-theme-neutral-tooltip-message-bg-color);position:absolute}.arrow:before{content:\"\";inset:0;transform:rotate(45deg);visibility:visible}:host([data-popper-placement^=bottom]) .arrow,:host([data-popper-placement^=top]) .arrow{left:50%;transform:translateX(-50%)}:host([data-popper-placement^=top]) .arrow{bottom:-4px}:host([data-popper-placement^=bottom]) .arrow{top:-4px}:host([data-popper-placement^=left]) .arrow,:host([data-popper-placement^=right]) .arrow{top:50%;transform:translateY(-50%)}:host([data-popper-placement^=left]) .arrow{right:-4px}:host([data-popper-placement^=right]) .arrow{left:-4px}";

const WuiTooltipLabel = /*@__PURE__*/ proxyCustomElement(class WuiTooltipLabel extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Where to place relative to target element
         */
        this.placement = 'top';
        /**
         * If opened
         */
        this.open = false;
        this.fixed = false;
    }
    componentDidLoad() {
        if (this.open) {
            this.show();
        }
    }
    componentWillUpdate() {
        if (this.open) {
            this.show();
        }
        else {
            this.hide();
        }
    }
    async show() {
        const p = waitForAnimation(this.elm, 'animation');
        this.popperInstance = createPopper(this.elm, {
            placement: this.placement,
            stretch: 'min',
            offset: 16,
            strategy: this.fixed ? 'fixed' : 'absolute',
            modifiers: [['arrow', this.arrowElm]],
        });
        this.elm.style.display = 'flex';
        await p;
    }
    async hide() {
        await waitForAnimation(this.elm, 'animation');
        this.elm.style.display = 'none';
        this.popperInstance = destroyPopper(this.popperInstance);
    }
    async disconnectedCallback() {
        if (this.open) {
            await this.hide();
        }
    }
    render() {
        return (h(Host, { key: 'fb1cc54fccb31bba8808e2aea6afebb82c0362a4', role: "tooltip" }, h("div", { key: '336d7dfd49b68a962dee55ab3b8b9c73a43de6ff', class: "inner", "data-chars": this.label && this.label.length > 30 }, h("div", { key: 'bb0fd12e417c259eebe27ebad12d661174c5c3f9' }, this.label)), h("div", { key: '24edc94d629be5b32d59674f96d18935816f967e', class: "arrow", "data-popper-arrow": true, ref: (el) => {
                this.arrowElm = el;
            } })));
    }
    get elm() { return this; }
    static get style() { return tooltipLabelCss; }
}, [257, "wui-tooltip-label", {
        "label": [1],
        "placement": [1],
        "open": [516],
        "fixed": [4]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTooltipLabel);
            }
            break;
    } });
}
defineCustomElement();

export { WuiTooltipLabel as W, defineCustomElement as d };
